import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// Superadmin-only guard for /admin/*
const ProtectedAdminRoute = ({ children }) => {
  const { loading, adminRole, user } = useAuth();

  if (loading) return null;

  const isSuperadmin = !!user?.is_superadmin || adminRole === 'superadmin';

  if (!isSuperadmin) {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
};

export default ProtectedAdminRoute;